import $ from 'jquery';

class AccordionRow {
  constructor(element){
    this.$el = $(element);
    this.$heading = this.$el.children('.accordion-heading, .table-row-heading');
    this.$heading.on('click', () => { this.toggleExpand(); });
  }

  toggleExpand(){
    if (!this.$el.hasClass('active')) {
      let headingHeight = this.$heading.outerHeight();
      let scrollTop = $(window).scrollTop();
      let windowHeight = $(window).height();

      if ((this.$el.offset().top + headingHeight) >= (scrollTop + windowHeight)) {
        $('html, body').animate({
          scrollTop: scrollTop + windowHeight/2
        }, 800);
      }
    }
    this.$el.toggleClass('active');
  }
}

export default AccordionRow;
